import { render, staticRenderFns } from "./AddressVerification.vue?vue&type=template&id=11028992&"
import script from "./AddressVerification.vue?vue&type=script&lang=js&"
export * from "./AddressVerification.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./AddressVerification.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports